export default __webpack_public_path__ + "static/media/Green.dcc04636.svg";